export const onDeleteItem = (id, dist) => ({
  widget: 'models',
  type: 'onDeleteItem',
  payload: { id, dist },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDeleteItem.js